/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Steps_HelpInputs */

const en_editor_steps_help = /** @type {(inputs: Editor_Steps_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter starts the next step. Times like "20 min" get a timer when cooking.`)
};

const de_editor_steps_help = /** @type {(inputs: Editor_Steps_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter beginnt den nächsten Schritt. Zeiten wie „20 Min.“ bekommen beim Kochen einen Timer.`)
};

/**
* | output |
* | --- |
* | "Enter starts the next step. Times like \"20 min\" get a timer when cooking." |
*
* @param {Editor_Steps_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_steps_help = /** @type {((inputs?: Editor_Steps_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Steps_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_steps_help(inputs)
	return en_editor_steps_help(inputs)
});